import React from 'react';
import Head from 'next/head';
import { RealEstateAgent } from 'schema-dts';
import { ORIGIN } from 'src/constants';

const RealEstateAgentSchema: React.FC = () => {
  const organization: RealEstateAgent = {
    '@type': 'RealEstateAgent',
    name: 'Condo Black Book',
    email: 'contact@CondoBlackBook.com',
    telephone: '(305) 697-7667',
    url: ORIGIN,
    openingHours: 'open 24 hours',
    priceRange: '$800,000-$100,000,000',
    description:
      'Blackbook Properties is a boutique luxury real estate brokerage specializing in South Florida residential, pre-construction, and investment condo properties.',
    image: `${ORIGIN}/images/logo.svg`,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1900 N BAYSHORE DR #1A',
      addressLocality: 'Miami',
      addressRegion: 'FL',
      addressCountry: 'United States',
      postalCode: '33132',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '25.794339',
      longitude: '-80.18705',
    },
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    ...organization,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Head>
  );
};

export default RealEstateAgentSchema;
